function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import _ from "lodash";
import { Row, Col, Spinner } from "react-bootstrap";
import "intelligent-tree-select/lib/styles.css";
import FontAwesome from "react-fontawesome";

var ReactTreeSelectFieldOption = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ReactTreeSelectFieldOption, _Component);

  function ReactTreeSelectFieldOption() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var props = _this.props;

      if (!_this.props.option.isEnd) {
        event.stopPropagation();
        return;
      }

      _this.props.selectValue(_this.props.option);

      console.log(event, props);
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function () {
      _this.props.focusOption(_this.props.option);

      _this.props.toggleOption(_this.props.option);

      _this.props.select.current.forceUpdate();
    });

    _defineProperty(_assertThisInitialized(_this), "isOptionSelected", function () {
      return _.some(_this.props.valueArray, function (selectedOption) {
        return selectedOption.value === _this.props.option.value;
      });
    });

    return _this;
  }

  var _proto = ReactTreeSelectFieldOption.prototype;

  _proto.render = function render() {
    var fetching = this.props.select.current.state.isLoadingExternally;
    var expanded = this.props.option.expanded;
    var isSelected = this.isOptionSelected();
    return /*#__PURE__*/React.createElement("li", {
      style: _extends({
        listStyleType: "none"
      }, this.props.optionStyle)
    }, /*#__PURE__*/React.createElement(Row, {
      style: {
        margin: "5px"
      },
      className: "align-items-center"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: "auto",
      md: "auto",
      onClick: this.handleToggle,
      style: {
        padding: "0 5px",
        margin: 0
      },
      className: "btn"
    }, fetching && "" + this.props.focusedOptionIndex === "" + this.props.optionIndex && /*#__PURE__*/React.createElement(Spinner, {
      size: "sm",
      animation: "border"
    }), !(fetching && "" + this.props.focusedOptionIndex === "" + this.props.optionIndex) && !this.props.option.isEnd && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FontAwesome, {
      name: expanded ? "minus-circle" : "plus-circle"
    }))), /*#__PURE__*/React.createElement(Col, {
      xs: "auto",
      style: {
        padding: 0,
        margin: 0,
        fontWeight: isSelected ? "bold" : "normal"
      },
      className: "btn",
      onClick: this.handleClick
    }, this.props.option.label)));
  };

  return ReactTreeSelectFieldOption;
}(Component);

;
export default ReactTreeSelectFieldOption;